// This is a separate .js file so that it can be picked up by the translation compiler
// TODO: Move this into BillingPages.tsx when translations support typescript files.

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

import stripe_png from './stripe_logo.png';
import i18n from 'FRONTEND/utils/i18n';

export const getPageProps = (pageType) => {
  switch (pageType) {
    case 'success':
      return {
        element: <CheckCircleOutlineIcon color='success' />,
        message: i18n._('Thank you for your payment!'),
      };
    case 'failure':
      return {
        element: <HighlightOffIcon color='error' sx={{ fontSize: 58 }} />,
        message: i18n._('Payment failed.'),
      };
    case 'already_paid':
      return {
        element: <CheckCircleOutlineIcon color='success' />,
        message: i18n._('This consultation has already been paid.'),
      };
    case 'invalid':
      return {
        element: <HighlightOffIcon color='error' />,
        message: i18n._('This consultation can no longer be paid. It may have been cancelled.'),
      };
    case 'stripe_redirect':
      return {
        element: <img src={stripe_png} alt='Stripe logo' />,
        message: i18n._('You will be redirected to Stripe in a few seconds...'),
      };
  }
};
